<template>
  <div>
    <!-- <div>lineId = {{lineId}}</div>
    <div>$liff_ID_Point = {{$liff_ID_Point}}</div> -->
  </div>
</template>

<script>
export default {
  beforeCreate() {
    this.$liff
      .init({ liffId: this.$liff_ID_SKLFamily })
      .then(() => {
        if (!this.$liff.isLoggedIn()) {
          this.$liff.login().then(() => {
            this.$liff.getProfile().then(profile => {
              this.lineProfile = profile;
              this.lineId = profile.userId;
              this.getCustomerProfile();
            });
          });
        } else {
          this.$liff.getProfile().then(profile => {
            this.lineProfile = profile;

            this.lineId = profile.userId;
            this.getCustomerProfile();
          });
        }
        this.$liff.getFriendship().then(data => {
          if (!data.friendFlag) {
            this.$liff.openWindow({
              url: `https://line.me/R/ti/p/${this.$liff_Channel_ID}`,
              external: false
            });
            this.$liff.closeWindow();
          }
        });
      })
      .catch(error => {
        console.error(error);
      });
  },
  created() {
    if (!this.lineId) {
      this.lineId = this.$route.params.LineId;
    }
    if (!this.lineId) {
      this.lineId = decodeURIComponent(window.location.search).split(
        "liff.state=/"
      )[1];
    }
    if (!this.lineId) this.lineId = this.$route.params.LineId;
  },

  data() {
    return {
      lineId: "",
      getOs: ""
    };
  },
  methods: {
    async sendReport() {
      if (!this.$route.query.linerichid) {
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$API_KEY_DEV_LINE_SKL);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        LineId: this.lineProfile.userId,
        LineRichId: this.$route.query.linerichid || "0",
        LineRichActionId: this.$route.query.linerichactiontid || "0",
        Sort: this.$route.query.sort || "0"
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch(`${this.$API_DEV_LINE_SKL}/ReportRichMenu`, requestOptions)
        .then(response => response.json())
        .then(result => {});
    },
    async getToken() {
        var requestOptions = {
        method: "GET",
        redirect: "follow",
        headers: {
          "api-key": this.$API_KEY_DEV_LINE_SKL
        }
      };

      this.getOs = this.$liff.getOS();

      fetch(
        `${this.$API_DEV_LINE_SKL}/customer/loginfamilyclub/${this.lineId}`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            if (result.detail.url) {
              // window.open(result.detail.url, "_self");
              // window.location.href = result.detail.url;
              // alert(`getOs = ${JSON.stringify(this.getOs)}`);

              if (this.getOs == "android") {
                this.$liff.openWindow({
                  url: `${result.detail.url}`,
                  external: false
                });
                setTimeout(() => {
                  this.$liff.closeWindow();
                }, 1000);
              } else {
                window.location.href = result.detail.url;
              }
            } else {
              window.open(`${this.$BASE_URL}/register`, "_self");
            }
          } else {
            window.open(`${this.$BASE_URL}/register`, "_self");
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    async getCustomerProfile() {
      this.$isLoadingAlpha = true;
        var requestOptions = {
        method: "GET",
        redirect: "follow",
        headers: {
          "api-key": this.$API_KEY_DEV_LINE_SKL
        }
      };

      await fetch(
        `${this.$API_DEV_LINE_SKL}/customer/profile/${this.lineProfile.userId}`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            if (result.detail.profile.isVerify) {
              // this.checkTerm(this.lineProfile.userId);
              this.sendReport();
              this.getToken();
            } else {
              this.$router.push("/register");
            }
          } else {
            this.$router.push("/register");
          }
          this.$isLoadingAlpha = false;
        })
        .catch(error => console.log("error", error));
    },
    closeWindow() {
      console.log("closeWindow is worked leff");
      try {
        this.$liff.closeWindow();
      } catch (error) {
        console.log(error);
      }

      console.log("closeWindow is worked windows");
      try {
        window.close();
      } catch (error) {
        console.log(error);
      }
    },
    checkTerm(lineId) {
      let myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$API_KEY_DEV_LINE_SKL);
      myHeaders.append("Content-Type", "application/json");
      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      };
      fetch(
        `${this.$API_DEV_LINE_SKL}/customer/checkterms/${lineId}`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          // alert(`/customer/checkterms/ response ${JSON.stringify(result)}`)
          if (result.result == 1) {
            if (!result.detail) {
              this.$router.push({
                path: "/policy",
                query: {
                  lineid: lineId,
                  term: true
                }
              });
              // let routeData = this.$router.resolve({
              //   name: "policy",
              //   query: { lineid: lineId }
              // });
              // window.open(routeData.href, "_blank");
            } else {
              this.getToken();
            }
          } else {
            // let routeData = this.$router.resolve({
            //   name: "policy",
            //   query: { lineid: lineId }
            // });
            // window.open(routeData.href, "_blank");
            this.$router.push({
              path: "/policy",
              query: {
                lineid: lineId,
                term: true
              }
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>

<style></style>
